export default "<div class=\"utah-gov-header ut-size-small\" role=\"banner\" aria-label=\"Utah.gov Header\"></div>\n"